import { Injectable } from '@angular/core'

import {
  COLLECTIVE_INVESTMENT_TRUST,
  STABLE_VALUE,
} from '../../../constants/constant.content'
import { NUMBER_TWO } from '../../../constants/constant.numbers'

@Injectable({
  providedIn: 'root',
})
export class SharedClassService {
  retirementSavingsTrustShareClassesList = []

  checkNameIsInList(list: string | any[], name: string) {
    for (let a = 0; a < list.length; a++) {
      if (list[a] === name) {
        return true
      }
    }
    return false
  }

  retirementSavingsTrustShareClasses(fund: any) {
    this.retirementSavingsTrustShareClassesList = []
    if (fund) {
      if (
        fund.productTypeLevel2 === COLLECTIVE_INVESTMENT_TRUST &&
        fund.investmentStrategy === STABLE_VALUE
      ) {
        const theShareClass = fund.fundShareClass
        if (
          !this.checkNameIsInList(
            this.retirementSavingsTrustShareClassesList,
            theShareClass,
          )
        ) {
          this.retirementSavingsTrustShareClassesList.push(theShareClass)
        }
      }
    }
    return this.retirementSavingsTrustShareClassesList
  }

  checkPatternKey(regex, keyArray) {
    for (let i = 0; i < keyArray.length; i++) {
      if (regex.test(keyArray[i])) {
        return false
      }
    }
    return true
  }

  getRelatedShareClassLength(relatedShareClasses) {
    return relatedShareClasses
      ? relatedShareClasses.length
        ? relatedShareClasses.length
        : 0
      : 0
  }

  createFilterRegEx(pattern) {
    return new RegExp('(?:' + pattern.join('|') + ')', 'i')
  }

  checkShareClassType(shareClass, regex, shareClassKey, keyArray) {
    if (shareClass === shareClassKey && this.checkPatternKey(regex, keyArray)) {
      return true
    }
    return false
  }

  createShareClassPattern(relatedShareClasses, length) {
    const pattern = []
    for (let i = 0; i < length; i++) {
      // temporarily assigning fundkeypattern = '' , can't find polaris endpoint for fund pattern
      const fundKeyPattern = relatedShareClasses[i].pattern
        ? relatedShareClasses[i].pattern
        : ''
      if (fundKeyPattern === 'IIP' || fundKeyPattern === '') {
        pattern.push(relatedShareClasses[i].shareclassType)
      }
    }
    return pattern
  }

  // eslint-disable-next-line complexity
  checkRelatedShareClass(shareClass, pattern) {
    const regex = this.createFilterRegEx(pattern)
    if (
      this.checkShareClassType(shareClass, regex, 'Institutional Plus', [
        'Institutional',
      ])
    ) {
      return true
    }
    if (
      this.checkShareClassType(shareClass, regex, 'Admiral', [
        'Institutional',
        'Institutional Plus',
      ])
    ) {
      return true
    }
    if (
      this.checkShareClassType(shareClass, regex, 'Signal', [
        'Admiral',
        'Institutional',
        'Institutional Plus',
      ])
    ) {
      return true
    }
    if (
      this.checkShareClassType(shareClass, regex, 'Investor', [
        'Signal',
        'Admiral',
        'Institutional',
        'Institutional Plus',
      ])
    ) {
      return true
    }
    if (
      this.checkShareClassType(shareClass, regex, 'Trust', [
        'Investor',
        'Signal',
        'Admiral',
        'Institutional',
        'Institutional Plus',
      ])
    ) {
      return true
    }
    return false
  }

  // eslint-disable-next-line max-statements, complexity
  checkForShareClasses(fund: any) {
    if (fund !== null) {
      const shareClass = fund.fundShareClass,
        relatedShareClasses = fund.shareClassList

      // do not use share classes for neither retirement savings trusts nor target retirement trusts
      if (
        shareClass === 'Institutional' ||
        this.checkNameIsInList(
          this.retirementSavingsTrustShareClassesList,
          shareClass,
        ) ||
        fund.investmentStrategy === 'Target Date'
      ) {
        return true
      }
      if (this.getRelatedShareClassLength(relatedShareClasses) === 0) {
        return true
      }
      // Added new condition
      if (
        shareClass === null &&
        this.getRelatedShareClassLength(relatedShareClasses) === NUMBER_TWO
      ) {
        return true
      }
      if (
        fund.portId === fund.parentPortId &&
        this.getRelatedShareClassLength(relatedShareClasses) === 1 &&
        fund.fundShareClass === null
      ) {
        return true
      }
      if (fund.fundShareClass && fund.fundShareClass === 'ETF') {
        return true
      }

      // pattern is an array of associated share class type such as ETF , Admiral or allshare class etc
      const pattern = this.createShareClassPattern(
        relatedShareClasses,
        this.getRelatedShareClassLength(relatedShareClasses),
      )
      if (pattern.length === 0) {
        return true
      }
      return this.checkRelatedShareClass(shareClass, pattern)
    }
  }
}
